<script setup lang="ts">

const links = [{
    label: 'Profile',
    icon: 'i-heroicons:user-circle-16-solid',
    to: 'profile'
}, {
    label: 'Orders',
    icon: 'i-heroicons:clock-16-solid',
    to: 'orders'
}, {
    label: 'Wishlist',
    icon: 'i-heroicons:clipboard-document-list-16-solid',
    to: 'wishlist'
}, {
    label: 'Coupons',
    icon: 'i-heroicons:tag-20-solid',
    to: 'coupons'
}, {
    label: 'Addresses',
    icon: 'i-heroicons:map-pin-16-solid',
    to: 'address'
}, {
    label: 'Payments',
    icon: 'i-heroicons:wallet-20-solid',
    to: 'payments'
}, {
    label: 'Notification',
    icon: 'ion:notifications',
    to: 'notifications'
}, {
    label: 'Ratings & Reviews',
    icon: 'i-heroicons:star-20-solid',
    to: 'ratings-reviews'
},]
</script>

<template>

    <div class="mt-2 bg-white shadow-md shadow-customPrimary-100">
        <div class="flex border items-center justify-start p-2">

            <UIcon name="i-heroicons-user-circle-16-solid" class="text-slate-400 h-8 w-8" />
            <span class="text-slate-800 pl-2">Hello,</span>
            <span class="block text-slate-800 pl-2">Manohar</span>
        </div>

        <UVerticalNavigation :links="links" class="h-screen" :ui="{
            wrapper: 'border-s border-gray-200 dark:border-gray-800 space-y-2',
            base: 'group block border-s -ms-px leading-snug before:hidden',
            padding: 'p-4 ps-4',
            rounded: '',
            font: 'font-medium',
            ring: '',
            icon: {
                base: 'mr-2 -mb-1', // Added padding here
                active: 'text-gray-600 dark:text-gray-200',
            },
            active: 'text-primary-500 dark:text-primary-400 border-current font-semibold text-lg bg-slate-100',
            inactive: 'text-lg border-transparent hover:border-gray-400 dark:hover:border-gray-500 text-gray-700 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-300'
        }" />
    </div>

</template>
